import React from "react"
import { Flex } from "@chakra-ui/react"

export function Wrapper({ children }) {
  return (
    <Flex flexDirection="column" position="relative" minHeight="100vh">
      {children}
    </Flex>
  )
}
